import tw, { styled } from 'twin.macro';

const StyledLabel = styled.label`
  ${tw`block text-sm font-medium text-gray-700 mb-1 pl-1`};
`;

export default StyledLabel;
